import { Card, Timeline } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { buildTimestampDateTime } from '../../helpers/formatters';
import { Resource_AppointmentMsg, Resource_AppointmentStatus } from '../../src/generated/graphql';
import styles from './appointment-details.module.scss';

interface AppointmentRebookingProps {
  appointment: Maybe<Resource_AppointmentMsg> | undefined;
}

/**
 * @deprecated - This component is deprecated and is about to be replaced by appointment-history.tsx
 *
 * @param appointment
 */
export const AppointmentRebooking: FC<AppointmentRebookingProps> = ({ appointment }) => {
  const { formatMessage } = useIntl();

  const bookingEvents = appointment?.eventHistory
    ?.filter(
      (event) => event?.appointmentStatus === Resource_AppointmentStatus.AppointmentStatusBooked,
    )
    ?.sort((a, b) => a!.happenedAt!.seconds! - b!.happenedAt!.seconds!);

  const appointmentRebooked = (bookingEvents?.length || 0) > 1;

  return appointmentRebooked ? (
    <Card className={styles.rebooking}>
      <Title level={3} style={{ fontWeight: 'bold', marginBottom: 10 }}>
        {formatMessage({ id: 'appointment.rebooking' })}
      </Title>
      <p className={styles.description}>
        {formatMessage({ id: 'appointment.reasons-for-rebooking' })}
      </p>
      <Timeline>
        {bookingEvents?.map((change, index) => {
          if (index === bookingEvents.length - 1) {
            return null;
          }

          return (
            <Timeline.Item key={change?.happenedAt?.seconds} color={'darkorange'}>
              <div>
                <div className={styles.rebookingEvent}>
                  {buildTimestampDateTime(change?.appointmentStartTime)}
                </div>
              </div>
            </Timeline.Item>
          );
        })}
      </Timeline>
      <div className={styles.newDateWrapper}>
        <b>
          {formatMessage(
            { id: 'appointment.rebooking.latest-date' },
            { date: buildTimestampDateTime(appointment?.startTime) },
          )}
        </b>
      </div>
    </Card>
  ) : null;
};
